import React, { useCallback } from 'react';
import {
  CategoryConfigurationDefinitionResponse,
  ConfigurationFieldType,
  ConfigurationSectionType,
} from '@ydistri/api-sdk';
import ConfigurationRow from './ConfigurationRow';
import { List } from 'antd';
import ConfigurationRowHeader from './ConfigurationRowHeader';
import ConfigurationEntityLists from './ConfigurationEntityLists/ConfigurationEntityLists';
import { entityListConfigurationDataTypes } from '../configurationUtils';
import SubconfigurationRow from './components/components';

const categoryConfigurationDefinitionGroupTitles: Record<
  ConfigurationSectionType,
  string | undefined
> = {
  [ConfigurationSectionType.PotentialSource]: 'Redistribution settings',
  [ConfigurationSectionType.PotentialTarget]: undefined,
  [ConfigurationSectionType.General]: 'Inventory definition',
  [ConfigurationSectionType.PotentialSourceStandardSubsection]:
    'Settings for standard redistribution',
  [ConfigurationSectionType.PotentialSourceForcedSubsection]: 'Settings for forced redistribution',
};

const scopeConfigurations: Partial<Record<ConfigurationFieldType, boolean>> = {
  [ConfigurationFieldType.PsSkuScope]: true,
  [ConfigurationFieldType.PtSkuScope]: true,
  [ConfigurationFieldType.PsSkuScopeForced]: true,
};

interface CategoryConfigurationGroupProps {
  sectionType: ConfigurationSectionType;
  data: CategoryConfigurationDefinitionResponse[];
  displayTitle?: boolean;
}

const CategoryConfigurationGroup: React.FC<CategoryConfigurationGroupProps> = ({
  sectionType,
  data,
  displayTitle = true,
}) => {
  const renderDefinition = useCallback((definition: CategoryConfigurationDefinitionResponse) => {
    if (entityListConfigurationDataTypes.includes(definition.dataType)) {
      if (scopeConfigurations[definition.fieldType]) {
        return <ConfigurationEntityLists definition={definition} key={definition.id} />;
      }
      return (
        <SubconfigurationRow>
          <ConfigurationEntityLists definition={definition} key={definition.id} />
        </SubconfigurationRow>
      );
    }
    if (definition.position === -1) return null;
    return (
      <SubconfigurationRow>
        <ConfigurationRow definition={definition} key={definition.id} />
      </SubconfigurationRow>
    );
  }, []);

  return (
    <>
      {displayTitle && (
        <ConfigurationRowHeader
          sectionType={sectionType}
          title={categoryConfigurationDefinitionGroupTitles[sectionType]}
        />
      )}
      <List
        dataSource={data}
        loading={false}
        size="small"
        renderItem={renderDefinition}
        data-testid={`ConfigurationGroup-${sectionType}`}
      />
      <SubconfigurationRow end />
    </>
  );
};

export default CategoryConfigurationGroup;
